import { render, staticRenderFns } from "./_so.vue?vue&type=template&id=2566195b"
import script from "./_so.vue?vue&type=script&lang=js"
export * from "./_so.vue?vue&type=script&lang=js"
import style0 from "./_so.vue?vue&type=style&index=0&id=2566195b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports